import React from "react";
import { BarracksUIProvider } from "./BarracksContext";
import BarracksWrapper from "./BarracksWrapper";

const Barracks = () => {
  return (
    <BarracksUIProvider>
      <BarracksWrapper />
    </BarracksUIProvider>
  );
};

export default Barracks;
